import {
  TimestampTypeRecord,
  TimestampTypeViewModelBase,
} from 'src/store/generated/timestamp-type-record.generated';

export class TimestampTypeViewModel extends TimestampTypeViewModelBase {
  constructor(timestampType: TimestampTypeRecord) {
    super(timestampType);
  }
}
